import type { CSSProperties } from "react";
import { avatar, type AvatarSize } from "@web/theme/theme";

export type AvatarProps = { name: string; size?: AvatarSize; /** Venue color ring (hex). */ ringColor?: string | null; className?: string };

export const initialsOf = (name: string) =>
  name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]!.toUpperCase())
    .join("") || "?";

export function Avatar({ name, size = "md", ringColor, className = "" }: AvatarProps) {
  const style = ringColor ? ({ "--bar": ringColor } as CSSProperties) : undefined;
  return (
    <span aria-hidden title={name} style={style} className={`${avatar.base} ${avatar.size[size]} ${ringColor ? avatar.ring : ""} ${className}`.trim()}>
      {initialsOf(name)}
    </span>
  );
}
